// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc5f902e","453":"482b4965","455":"b7204d30","504":"9ab43d46","977":"9558fe4b"}[chunkId] + ".chunk.js";
};